var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "8px",
    viewBox: "0 0 10 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.773333333,4.63555556 C0.702222222,4.56622222 0.666666667,4.46222222 0.666666667,4.39288889 C0.666666667,4.32355556 0.702222222,4.21955556 0.773333333,4.15022222 L1.27111111,3.66488889 C1.41333333,3.52622222 1.62666667,3.52622222 1.76888889,3.66488889 L1.80444444,3.69955556 L3.76,5.74488889 C3.83111111,5.81422222 3.93777778,5.81422222 4.00888889,5.74488889 L8.77333333,0.926222222 L8.80888889,0.926222222 C8.95111111,0.787555556 9.16444444,0.787555556 9.30666667,0.926222222 L9.80444444,1.41155556 C9.94666667,1.55022222 9.94666667,1.75822222 9.80444444,1.89688889 L4.11555556,7.65155556 C4.04444444,7.72088889 3.97333333,7.75555556 3.86666667,7.75555556 C3.76,7.75555556 3.68888889,7.72088889 3.61777778,7.65155556 L0.844444444,4.73955556 L0.773333333,4.63555556 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    transform: "translate(-103.000000, -519.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Date-joined",
    transform: "translate(12.000000, 510.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icTick",
    transform: "translate(91.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTick);
export default __webpack_public_path__ + "static/media/icTick.005664cc7fa4a9cb26e18f5955f720db.svg";
export { ForwardRef as ReactComponent };